<template>
  <internal-bill-info ref="internalBillInfo" :context="context" :action="action" :location="location" :enable-ui-custom="enableUiCustom" :page-type="pageType" />
</template>

<script>
import { AbstractEntity as Job } from '@/class/model/AbstractEntity'
import InternalBillInfo from './internalBillInfo'

export default {
  name: 'TabInternalBill',
  components: { InternalBillInfo },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    location: { type: String, required: false },
    enableUiCustom: { type: Boolean, default: false }, // 是否启用UI自定义
    pageType: { type: Number, default: 0 } // UI自定义页签类型
  },
  data() {
    return {
      masterFlag: false,
      job: new Job().fillDefaultValue().getData()
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      this.masterFlag = row.masterFlag || false
      if (!isRefresh && this.isEdit) {
        return
      }
      if (!row.uuid) {
        return
      }
      this.job = row
      // 调用子组件
      this.$refs.internalBillInfo.onShow(row)
    },
    // 打印
    getPrintData() {
      // 调用子组件
      this.$refs.internalBillInfo.getPrintData()
      return null
    }
  }
}
</script>

<style>
</style>
